import { model as i18n, type TOptionsBase } from '!/i18n'
import { combine, type Store } from 'effector'

const getOptions = (i18nextOptions?: TOptionsBase): TOptionsBase => {
  if (!i18nextOptions) return {}
  return i18nextOptions
}

// helper for create translated store type object
export const translatedObjectStore = (
  keysObject: Record<string, string>,
  i18nextOptions?: TOptionsBase
): Store<Record<string, string>> =>
  combine(i18n.$t, ({ t }) => {
    const options = getOptions(i18nextOptions)
    return Object.keys(keysObject).reduce((acc, key) => {
      const translation = keysObject[key]
      return {
        ...acc,
        [key]: t(translation, {
          ...options,
        }),
      }
    }, {})
  })
